export default __webpack_public_path__ + "static/media/icons8-html-5.f064b374.svg";